export default __webpack_public_path__ + "static/media/edit.b8b1270f.svg";